const TEAM_MEMBER_ROLE = 'Team Member';

export const DOMAIN_ERROR =
  'Domain is not present. Contact integration team to onboard email domain.';

export const VALIDATION_ERROR = 'Failed to validate. Please try again.';

export const parseSendEmailValue = (sendEmail) =>
  sendEmail != null && String(sendEmail) === 'no' ? 'no' : 'yes';

export const isDomainCheckSuccess = (item) =>
  item?.isPresent === true || item?.status === 'SUCCESS';

export const findDomainCheckItem = (response, email) => {
  const items = response?.emails || [];
  if (!email) {
    return undefined;
  }

  const lowerEmail = email.toLowerCase();
  return items.find((item) => item?.email?.toLowerCase() === lowerEmail);
};

export const buildDomainCheckResponseMap = (response) => {
  const map = new Map();
  (response?.emails || []).forEach((item) => {
    if (item?.email) {
      map.set(item.email.toLowerCase(), item);
    }
  });
  return map;
};

export const toFlatDomainCheckResult = (item) => {
  if (!item) {
    return {
      isPresent: false,
      description: VALIDATION_ERROR,
      status: 'ERROR',
    };
  }

  return {
    email: item.email,
    isPresent: isDomainCheckSuccess(item),
    description: item.description,
    sendEmail: item.sendEmail,
    status: item.status,
    authPattern: item.authPattern,
  };
};

export const buildDomainCheckPreviewRow = (email, item) => {
  if (!item) {
    return {
      email,
      status: 'invalid',
      reason: VALIDATION_ERROR,
      details: VALIDATION_ERROR,
    };
  }

  if (isDomainCheckSuccess(item)) {
    return {
      email,
      status: 'valid',
      reason: '',
      details: 'Will be added as Team Member',
      memberData: {
        email,
        name: '',
        role_name: TEAM_MEMBER_ROLE,
        isEUBased: null,
        sendEmail: parseSendEmailValue(item.sendEmail),
      },
    };
  }

  const domainError = item.description || DOMAIN_ERROR;
  return {
    email,
    status: 'invalid',
    reason: domainError,
    details: domainError,
  };
};
